// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2_nXW","subheader":"ReorderModal_subheader__2MZdy","listWrap":"ReorderModal_listWrap__1O2wl"};